import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'sectorofcare',
    name: 'sectorofcare',
    component: Form,
    redirect: { name: 'sectorofcare-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'sectorofcare-list',
        component: () => import('@/views/sectorsOfCare/SectorOfCareList.vue'),
        meta: {
          header: {
            label: () => i18n.tc('sectorofcare.label', 2),
          },
        },
      },
      {
        path: 'create',
        name: 'sectorofcare-create',
        component: () => import('@/views/sectorsOfCare/SectorOfCareCreate.vue'),
        meta: {
          header: {
            route: { name: 'sectorofcare-list' },
            label: () =>
              i18n.t('title.create', [i18n.tc('sectorofcare.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id',
        name: 'sectorofcare-edit',
        component: () => import('@/views/sectorsOfCare/SectorOfCareEdit.vue'),
        meta: {
          header: {
            route: { name: 'sectorofcare-list' },
            label: () =>
              i18n.t('title.edit', [i18n.tc('sectorofcare.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
